
import React from 'react';
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CountryList from '@/components/country/CountryList';
import BackToTop from "@/components/ui/BackToTop";

const Countries = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 pt-24">
        <div className="max-w-4xl mx-auto mb-10 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-nation-blue mb-4">
            NationCard™ Countries
          </h1>
          <p className="text-lg text-gray-700">
            Explore all the countries where NationCard is available or coming soon.
          </p>
        </div>
        
        <CountryList />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Countries;
